angular.module('aprima-core-ui').directive('apDocumentViewer', [
    'BrowserService',
    'ViewportInfo',
    '$sce',
        function (
            BrowserService,
            ViewportInfo,
            $sce
        ) {
            'use strict';

            var imageFormats = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'rtf', 'doc', 'docx', 'tif', 'tiff'];
            var htmlFormats = ['html', 'htm'];
            var textFormats = ['txt'];
            var pdfFormats = ['pdf'];


            // We need to request a resolution for any pdfs to be rendered at, so we want to leverage the devices native resolution so that devices that are higher res
            // have less of a chance seeming pixelated at zoom factors.  Happy side effect is that lower res devices tend to be less powerful, and this will give us smaller
            // images for those devices.
            var pageWidth = ViewportInfo.getWidth();
            var pageHeight = ViewportInfo.getHeight();

            return {
                restrict: 'E',
                templateUrl: '/core-ui/views/directives/apDocumentViewer.html',
                replace: true,
                scope: {
                    disableFullscreen: '<?',
                    disableInlinePdf: '<?',
                    documentId: '=',
                    loadDocument: '&loadFunction',
                },
                link: function ($scope) {

                    //ap-image-viewer is 1-based instead of 0-based. First page has an index of 1.

                    $scope.pageDetails = {
                        page: $scope.page || 1,
                        currentPage: $scope.currentPage || 1
                    };

                    $scope.loadPage = loadPage;

                    $scope.$watch('documentId', function (newValue, oldValue) {
                        tryLoadAttachment(1, oldValue);
                    });

                    function loadPage(page) {
                        tryLoadAttachment(page, $scope.documentId);
                    }

                    function tryLoadAttachment(page, previousDocumentId) {
                        if (_.isNumber(page)) {
                            $scope.pageDetails.currentPage = $scope.page = page;
                        }
                        loadAttachment($scope, $scope.documentId, previousDocumentId, $scope.page);
                    }
                }
            };


            function loadAttachment($scope, documentId, previousDocumentId, page) {
                if(documentId !== previousDocumentId) {
                    $scope.loadError = null;
                    $scope.attachment = null;
                    $scope.isImage = false;
                    $scope.isHtml = false;
                    $scope.isText = false;
                    $scope.isPdf = false;
                }

                if(!documentId) {
                    return;
                }

                $scope.loadingAttachment = true;

                var request = {
                    page: page,
                    // Request double the device's resolution so we have a little give in the zooming department.
                    height: pageHeight * 2,
                    width: pageWidth * 2
                };

                $scope.loadDocument({documentId: documentId, requestSettings: request})
                    .then(function (attachment) {
                        $scope.attachment = attachment;
                        $scope.attachment.attachmentData = attachment.Data;

                        $scope.isImage = _.includes(imageFormats, attachment.Extension);
                        $scope.isHtml = _.includes(htmlFormats, attachment.Extension);
                        $scope.isText = _.includes(textFormats, attachment.Extension);
                        $scope.isPdf = _.includes(pdfFormats, attachment.Extension);

                        if ($scope.isImage) {
                            //make apImageViewer happy
                            $scope.attachment.imageData = 'data:image/' + attachment.Extension + ';base64,' + attachment.Data;
                        }
                        else if ($scope.isHtml) {
                            $scope.attachment.htmlData = $sce.trustAsResourceUrl('data:text/html;charset=utf-8; base64,' + attachment.Data);
                        }
                        else if ($scope.isText) {
                            $scope.attachment.textData = atob(attachment.Data);
                        }
                        else if ($scope.isPdf) {
                            var blob = BrowserService.base64ToBlob(attachment.Data, 'application/pdf');
                            var fileURL = window.URL.createObjectURL(blob);
                            $scope.attachment.pdfData = $sce.trustAsResourceUrl(fileURL);
                        }
                    })
                    .catch(function (response) {
                        $scope.loadError = response;
                    })
                    .finally(function () {
                        $scope.loadingAttachment = false;
                    });
            }
        }]);
